// Rules for choosing an account password (sign-up and password reset). Logging in with an existing password is never blocked.
export const PASSWORD_RULES = [
  { id: "len", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { id: "letter", label: "A letter", test: (p) => /\p{L}/u.test(p) },
  { id: "number", label: "A number", test: (p) => /\d/.test(p) },
  { id: "special", label: "A special character (like ! ? # $ %)", test: (p) => /[^\p{L}\d\s]/u.test(p) },
];

export const passwordChecks = (p) => PASSWORD_RULES.map((r) => ({ id: r.id, label: r.label, ok: r.test(String(p || "")) }));

// "" if the password is acceptable, otherwise the first rule it breaks.
export function passwordProblem(p) {
  const bad = passwordChecks(p).find((c) => !c.ok);
  return bad ? `Your password needs: ${bad.label.toLowerCase()}.` : "";
}
